import React from 'react';
import Lottie from 'lottie-react';
import animateNotFound from '@/assets/animations/not-found-animation.json';
import dynamic from 'next/dynamic';

const AnimationNotFound = () => {
  return <PlayerWithNoSSR animationData={animateNotFound} className="h-full w-full" loop />;
};

const PlayerWithNoSSR = dynamic(() => import('lottie-react').then((module) => module.default), {
  ssr: false,
});

export default AnimationNotFound;
